export default [
  {
    path: '/report/daily-sale-items',
    name: 'daily-sale-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/daily-sale-item.vue')
  },
  {
    path: '/report/sale-item-details',
    name: 'sale-item-detail',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/sale-item-detail.vue')
  },
  {
    path: '/report/stock-in-details',
    name: 'stock-in-detail',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-in-detail.vue')
  },
  {
    path: '/report/stock-in-summaries',
    name: 'stock-in-summary',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-in-summary.vue')
  },
  {
    path: '/report/detail-inventory-lists',
    name: 'report-detail-inventory-list',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/detail-inventory-list.vue')
  },
  {
    path: '/report/summary-inventory-lists',
    name: 'report-summary-inventory-list',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/summary-inventory-list.vue')
  },
  {
    path: '/report/product-item-lists',
    name: 'product-item-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/product-item-list.vue')
  },
  {
    path: '/report/purchase-order-lists',
    name: 'purchase-order-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/purchase-order-list.vue')
  },
  {
    path: '/report/purchase-order-summaries',
    name: 'purchase-order-summary',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/purchase-order-summary.vue')
  },
  {
    path: '/report/monthly-sale-items',
    name: 'monthly-sale-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/monthly-sale-item.vue')
  },
  {
    path: '/report/stock-transfers',
    name: 'report-stock-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-transfer.vue')
  },
  {
    path: '/report/yearly-sale-items',
    name: 'report-yearly-sale-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/yearly-sale-item.vue')
  },
  {
    path: '/report/inventory-list-head-offices',
    name: 'report-inventory-list-head-office',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/inventory-list-head-office.vue')
  }
]
